export default "__VITE_ASSET__CmSggDKV__"